"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Component;
}(vue_1.default));
exports.Component = Component;
/**
 * Create component from component options (Compatible with Vue.extend)
 */
function createComponent(opts) {
    return vue_1.default.extend(opts);
}
exports.createComponent = createComponent;
var factoryImpl = {
    convert: function (c) { return c; },
    extendFrom: function (c) { return c; }
};
/**
 * Specify Props and Event types of component
 *
 * Usage:
 *  // Get TSX-supported component with props(`name`, `value`) and event(`onInput`)
 *  const NewComponent = tsx.ofType<{ name: string, value: string }, { onInput: string }>.convert(Component);
 */
function ofType() {
    return factoryImpl;
}
exports.ofType = ofType;
function withNativeOn(componentType) {
    return componentType;
}
exports.withNativeOn = withNativeOn;
function withHtmlAttrs(componentType) {
    return componentType;
}
exports.withHtmlAttrs = withHtmlAttrs;
function withUnknownProps(componentType) {
    return componentType;
}
exports.withUnknownProps = withUnknownProps;
function withPropsObject(componentType) {
    return componentType;
}
exports.withPropsObject = withPropsObject;
function createComponentFactory(base, mixins) {
    return {
        create: function (options) {
            var mergedMixins = options.mixins ? options.mixins.concat(mixins) : mixins;
            return base.extend(__assign({}, options, { mixins: mergedMixins }));
        },
        mixin: function (mixinObject) {
            return createComponentFactory(base, mixins.concat([mixinObject]));
        }
    };
}
function createExtendableComponentFactory() {
    return {
        create: function (options) {
            return vue_1.default.extend(options);
        },
        extendFrom: function (base) {
            return createComponentFactory(base, []);
        },
        mixin: function (mixinObject) {
            return createComponentFactory(vue_1.default, [mixinObject]);
        }
    };
}
exports.componentFactory = createExtendableComponentFactory();
function componentFactoryOf() {
    return exports.componentFactory;
}
exports.componentFactoryOf = componentFactoryOf;
/**
 * Shorthand of `componentFactory.create`
 */
exports.component = exports.componentFactory.create;
exports.extendFrom = exports.componentFactory.extendFrom;
function emit(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, [name].concat(args));
}
exports.emit = emit;
function emitOn(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, [name.replace(/^on[A-Z]/, function (v) { return v[2].toLowerCase(); })].concat(args));
}
exports.emitOn = emitOn;
function emitUpdate(vm, name, value) {
    vm.$emit("update:" + name, value);
}
exports.emitUpdate = emitUpdate;
//# sourceMappingURL=data:application/json;base64,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